var React = require('react');

function PlayRoundIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"className":"sample-button","d":"M 122.88 61.44 C 122.88 95.373 95.372 122.88 61.44 122.88 C 27.508 122.88 0 95.373 0 61.44 C 0 27.508 27.508 0 61.44 0 C 95.372 0 122.88 27.508 122.88 61.44 Z M 84.91 65.52 C 88.32 63.32 88.32 60.86 84.91 58.91 L 49.63 38.63 C 46.85 36.88 43.94 37.91 44.02 41.55 L 44.13 82.53 C 44.37 86.47 46.62 87.55 49.93 85.72 Z"}));
}

PlayRoundIcon.defaultProps = {"viewBox":"0 0 122.88 122.88","style":{"enableBackground":"new 0 0 122.88 122.88"}};

module.exports = PlayRoundIcon;

PlayRoundIcon.default = PlayRoundIcon;
